import React from 'react';
import PropTypes from 'prop-types';
import Label from '@gerenciatd/next.components.label';
import TextInfo from '@gerenciatd/next.components.text-info-n';
import Imagen from '@gerenciatd/next.components.image-n';
import CustomLink from '@gerenciatd/next.components.custom-link';


const PRODUCT_CARD_WIDTH = {
  SIMPLE: 'simpleWidth',
  DOUBLE: 'doubleWidth'
}

const ProductCard = (props) => {
  const { width, custoObjectInfo, taggingInfo } = props;

  let textInfoCustoObjectInfo1 = null;
  let textInfoCustoObjectInfo2 = null;
  let textInfoCustoObjectInfo3 = null;
  let textInfoCustoObjectInfo4 = null;
  let labelCustoObjectInfo1 = null;
  let imageCustoObjectInfo1 = null;
  let customLinkCustoObjectInfo1 = null;
  if (custoObjectInfo){
    textInfoCustoObjectInfo1 = custoObjectInfo.addEntryPoint({
      custoObjectInfo,
      entryPoint: 'TextInfo-1',
    })
    textInfoCustoObjectInfo2 = custoObjectInfo.addEntryPoint({
      custoObjectInfo,
      entryPoint: 'TextInfo-2',
    })
    textInfoCustoObjectInfo3 = custoObjectInfo.addEntryPoint({
      custoObjectInfo,
      entryPoint: 'TextInfo-3',
    })
    textInfoCustoObjectInfo4 = custoObjectInfo.addEntryPoint({
      custoObjectInfo,
      entryPoint: 'TextInfo-4',
    })
    labelCustoObjectInfo1 = custoObjectInfo.addEntryPoint({
      custoObjectInfo,
      entryPoint: 'Label-1',
    })
    imageCustoObjectInfo1 = custoObjectInfo.addEntryPoint({
      custoObjectInfo,
      entryPoint: 'Image-1',
    })
    customLinkCustoObjectInfo1 = custoObjectInfo.addEntryPoint({
      custoObjectInfo,
      entryPoint: 'CustomLink-1',
    })
  }

  return (
    <>
      <div className={`ProductCard ${width}`}>
        {props['Image-1'] && (
            <div className="ImageGap">
              <Imagen {...props['Image-1']} objectFit="cover" custoObjectInfo={imageCustoObjectInfo1} objectPosition="center"/>
            </div>
        )}
        <div className="content">
          {props['Label-1'] && (
              <Label {...props['Label-1']} custoObjectInfo={labelCustoObjectInfo1} />
           )}
          {props['TextInfo-1'] &&  (
            <div className='TextInfoGap1'>
              <TextInfo {...props['TextInfo-1']} custoObjectInfo={textInfoCustoObjectInfo1} />
            </div> 
          )}
          {props['TextInfo-2'] &&  (
            <div className='TextInfoGap2'>
              <TextInfo {...props['TextInfo-2']} custoObjectInfo={textInfoCustoObjectInfo2} />
            </div>
          )}
          {props['TextInfo-3'] &&  (
            <div className='TextInfoGap3'>
              <TextInfo {...props['TextInfo-3']} custoObjectInfo={textInfoCustoObjectInfo3} />
            </div>
          )}
          {props['TextInfo-4'] && (
            <div className='TextInfoGap4'>
              <TextInfo {...props['TextInfo-4']} custoObjectInfo={textInfoCustoObjectInfo4} />
            </div>
          )}
          {props['CustomLink-1'] && (
            <CustomLink  {...props['CustomLink-1']} custoObjectInfo={customLinkCustoObjectInfo1} />
          )}
        </div>
      </div>
      <style jsx>
        {`
          .ProductCard {
            position:relative;
            box-shadow: 0 0 10px 0 rgb(0 0 0 / 16%);
            margin: 0.25rem;
            background-color:white;
            .ImageGap {
              position: relative;
              width:100%;
              height: 11rem;
            }
            &.simpleWidth {
              width: 18.75rem;
            }
            &.doubleWidth {
              width: 35.94rem;
            }
            .content {
              padding: 1rem 0.5rem;
              .TextInfoGap1, .TextInfoGap3, .TextInfoGap4 {
                margin-top: 1rem;
              }
            }
          }
          @media screen and (max-width:980px){
            .ProductCard{
              &.simpleWidth {
                width: 48%;
              }
              &.doubleWidth {
                width:100%;
              }
              margin-bottom: 1rem;
            }
          }
          @media screen and (max-width:580px){
            .ProductCard{
              &.simpleWidth {
                width:100%;
              }
              &.doubleWidth {
                width:100%;
              }
              margin: 1rem auto;
            }
          }
        `}
      </style>
    </>
  );

}

ProductCard.propTypes = {
  width: PropTypes.string,
}

ProductCard.defaultProps = {
  width: PRODUCT_CARD_WIDTH.SIMPLE,
}

export default ProductCard;
